











































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { PrescricaoHistDTO } from '@/interfaces/prescription-hist';
import * as service from '@/services/prescription-hist';
import Component from 'vue-class-component';
import ProductLineChart from './product-line-chart.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiAutocomplePatients,
    ProductLineChart,
  },
})
export default class PatientEvolution extends BaseComponent {
  private unidade = null;
  private paciente = null;
  private loading = false;
  private error = false;
  private dias = 30;
  private itensPeriodo = [
    { id: 3, label: '3 dias' },
    { id: 7, label: '7 dias' },
    { id: 15, label: '15 dias' },
    { id: 30, label: '30 dias' },
    { id: 60, label: '60 dias' },
    { id: 90, label: '90 dias' },
    { id: 180, label: '6 meses' },
    { id: 365, label: '1 ano' },
    { id: 730, label: '2 anos' },
    { id: 1095, label: '3 anos' },
  ];

  private headers = [];
  private items: PrescricaoHistDTO[] = [];
  private itemsOrdemDesc: PrescricaoHistDTO[] = [];
  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  private menuAtivo = [];
  private executado = false;
  private loadingXls = false;
  private loadingPdf = false;

  mounted() {
    /*
    this.paciente = { id: 3199 };
    this.dias = 1000;
    this.exec();
    */
  }

  private exec() {
    this.executado = true;
    this.loading = true;
    this.error = false;
    this.items = [];
    service.listarDadosEvolucaoPaciente(this.paciente.id, this.dias).subscribe(
      (res) => {
        this.buildHeaders(res);
        this.items = res;
        this.itemsOrdemDesc = Object.assign(new Array(), this.items);
        this.itemsOrdemDesc = this.itemsOrdemDesc.reverse();
        this.loading = false;
        this.pagination.rowsPerPage = 10;
      },
      (error) => {
        this.loading = false;
        this.error = true;
        this.showToastApiError(error);
      },
    );
  }

  private buildHeaders(res: PrescricaoHistDTO[]) {
    this.headers = [];
    if (!res.length) {
      return;
    }
    this.headers = [
      { text: 'Id', value: 'idSeqSipro', sortable: false },
      { text: 'Data', value: 'data', sortable: false },
      { text: 'Médico', value: 'nomeMedico', sortable: false },
      { text: 'Peso (kg)', value: 'pesoPaciente', sortable: false, chart: true },
      { text: 'Volume Total (mL)', value: 'volume', sortable: false, chart: true },
      { text: 'Via', value: 'viaAdministracao', sortable: false },
      { text: 'Velocidade (h)', value: 'tempoInfusao', sortable: false, chart: true },
      { text: 'Osmolaridade', value: 'osmolaridade', sortable: false, chart: true },
    ];
    res[0].produtos.forEach((p) => {
      this.headers.push({
        text: p.nome + " (mL)",
        value: 'P-' + p.id,
        sortable: false,
        produto: true,
        idProduto: p.id,
        chart: true,
      });
    });
  }

  private getChartDataProduto(idProduto) {
    if (!idProduto) {
      return [];
    }
    let chartData: any = [['Dia', 'Quantidade (mL)']];
    this.itemsOrdemDesc.forEach((i) => {
      chartData.push([
        i.data,
        i.produtos.filter((p) => p.id == idProduto)[0].quantidadeMl
          ? i.produtos.filter((p) => p.id == idProduto)[0].quantidadeMl
          : 0,
      ]);
    });

    return chartData;
  }

  private getChartDataProp(nomeProp) {
    if (!nomeProp) {
      return [];
    }
    let chartData: any = [['Dia', 'Valor']];
    this.itemsOrdemDesc.forEach((i) => {
      chartData.push([i.data, i[nomeProp]]);
    });
    return chartData;
  }

  private exportarExcel() {
    this.loader.start('Gerando XLS...');
    this.loadingXls = true;
    service.gerarXlsEvolucaoPaciente(this.paciente.id, this.dias).subscribe(
      (res) => {
        this.loader.stop();
        this.forceFileAxiosResponseDownload(res, 'relatorio.xls');
        this.loadingXls = false;
      },
      (error) => {
        this.loader.stop();
        this.loadingXls = false;
        this.showToastApiError(error);
      },
    );
  }

  private exportarPdf() {
    this.loader.start('Gerando PDF...');
    this.loadingPdf = true;
    service.gerarPdfEvolucaoPaciente(this.paciente.id, this.dias).subscribe(
      (res) => {
        this.loader.stop();
        this.forceFileAxiosResponseDownload(res, 'relatorio.pdf');
        this.loadingPdf = false;
      },
      (error) => {        
        this.loader.stop();
        this.loadingPdf = false;        
        this.showToastApiError(error);
      },
    );
  }
}
